import { css, CSSResult } from 'lit'
import { csFormControl } from 'elements/_shared/form.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { csColorBackground } from '@cloudsuite/mosaic-shared/styles/colors.style.js'


export const cseOption = {
  backgroundColor: css`var(--cse-option-background-color, ${csFormControl.backgroundColor})`,
  color: css`var(--cse-option-color, ${csFormControl.color})`,
  colorHover: css`var(--cse-option-color-hover, ${csFormControl.colorHover})`,
  fontFamily: css`var(--cse-option-font-family, ${csFormControl.fontFamily})`,
  columnGap: css`var(--cse-option-column-gap, ${csSpacing.spacing05})`,

  selectPaddingBlock: css`var(--cse-option-select-padding-y, 0)`,
  selectPaddingInline: css`var(--cse-option-select-padding-x, ${csSpacing.spacing05})`,

  searchBackgroundColorHover: css`var(--cse-option-search-background-color-hover, ${csColorBackground.info})`,
  searchPaddingBlock: css`var(--cse-option-search-padding-y, ${csSpacing.spacing05})`,
  searchPaddingInline: css`var(--cse-option-search-padding-x, ${csSpacing.spacing05})`,

  selectedBackgroundColor: css`var(--cse-option-selected-background-color, ${csFormControl.backgroundColorSelected})`,
  colorDisabled: css`var(--cse-option-color-disabled, ${csFormControl.colorDisabled})`,
  outlineFocus: css`var(--cse-option-outline-focus, ${csFormControl.outlineFocus})`,
}

export const style: CSSResult = css`
  .cse-option {
    align-items: center;
    background-color: ${cseOption.backgroundColor};
    color: ${cseOption.color};
    column-gap: ${cseOption.columnGap};
    display: flex;
    font-family: ${cseOption.fontFamily};
    justify-content: space-between;
    user-select: none;
    width: 100%;
  }

  .cse-option:focus {
    outline: ${cseOption.outlineFocus};
  }

  [icon-role="cse-option.arrow"] {
    opacity: 0;
  }

  .variant-select {
    padding-block: ${cseOption.selectPaddingBlock};
    padding-inline: ${cseOption.selectPaddingInline};
  }

  .variant-select:hover {
    --cse-text-color: ${cseOption.colorHover};
    color: ${cseOption.colorHover};
  }

  .variant-search {
    padding-block: ${cseOption.searchPaddingBlock};
    padding-inline: ${cseOption.searchPaddingInline};
  }

  .variant-search:hover:not(.disabled) {
    background-color: ${cseOption.searchBackgroundColorHover};
  }

  .variant-search:hover [icon-role="cse-option.arrow"] {
    color: ${cseOption.colorHover};
  }

  .cse-option:hover:not(.disabled) [icon-role="cse-option.arrow"] {
    opacity: 1;
  }

  .cse-option.selected {
    background-color: ${cseOption.selectedBackgroundColor};
  }

  .cse-option:not(.disabled) {
    cursor: pointer;
  }

  .cse-option.disabled {
    --cse-text-color: ${cseOption.colorDisabled};
    color: ${cseOption.colorDisabled};
  }

  #label-text {
    display: block;
    margin-right: auto;
  }

  .icon {
    pointer-events: none;
  }
`
